import React, { useRef } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPaperclip } from '@fortawesome/free-solid-svg-icons';

// Utilities

import { truncateString  } from '../../../utilities/helper-functions';

import './Styles.scss';

const fileTypes = {
    image: "image/x-png,image/jpeg",
    excel: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    pdf: "application/pdf"
}

export default function FileInput(props) {
    const {
        formik,
        fieldName,
        label,
        isRequired,
        fileType,
        roundedStyle,
        multiple = false
    } = props;

    const fileUpload = useRef(null);

    const getDisplayText = () => {
        if (!formik.values[fieldName]) {
            return 'Seleccionar archivo' + (multiple ? 's' : '');
        }
        
        if (multiple && formik.values[fieldName].length) {
            return `${formik.values[fieldName].length} archivo${formik.values[fieldName].length > 1 ? 's' : ''} seleccionado${formik.values[fieldName].length > 1 ? 's' : ''}`;
        }
        
        return truncateString(formik.values[fieldName].name, 30);
    };

    const handleFileChange = (event) => {
        const files = event.currentTarget.files;
        if (multiple) {
            formik.setFieldValue(fieldName, Array.from(files));
        } else {
            formik.setFieldValue(fieldName, files[0]);
        }
    };

    return (
        <div className={roundedStyle ? "field" : "field field-alt"}>
            {label &&
            <label>{label}</label>}

            <button
                className={formik.touched[fieldName] && formik.errors[fieldName] ? "file-input-button input-error" : "file-input-button"}
                onClick={() => fileUpload.current.click()}
            >
                <FontAwesomeIcon icon={faPaperclip} /> {getDisplayText()}
            </button>

            <input
                ref={fileUpload}
                className="file-input"
                id={fieldName}
                name={fieldName}
                type="file" 
                accept={fileType ? fileTypes[fileType] : fileTypes.image}
                multiple={multiple}
                onChange={handleFileChange}
                onBlur={formik.handleBlur(fieldName)}
                required={isRequired}
            />

            <span className='field-error'>{formik.touched[fieldName] && formik.errors[fieldName]}</span>

        </div>
    )
}
